import { MembersModalForm } from "./MembersModalForm";

const MembersModalFormWrapper = ({
  members,
  isUserProfile,
  onClose
}) => {
  return (
    <MembersModalForm
      members={members}
      isUserProfile={isUserProfile}
      onClose={onClose}
    />
  );
};

export { MembersModalFormWrapper };
